import { Component, computed, input } from '@angular/core';
import { CardPrice, cardPriceFootnotes } from '../../models/dzbank-configuration.model';

@Component({
  selector: 'ez-card-price-footnotes',
  templateUrl: './card-price-footnotes.component.html',
  styleUrl: './card-price-footnotes.component.scss',
})
export class CardPriceFootnotesComponent {
  readonly cardPrice = input.required<CardPrice>();
  protected readonly footnotes = computed(() => cardPriceFootnotes(this.cardPrice()));
}
